import { findGuide } from './guides';

import type { RouteRecordRaw } from 'vue-router';

export const helpRoute: RouteRecordRaw = {
  path: '/help',
  name: 'Help',
  component: () => import('./pages/HelpIndexPage.vue'),
  meta: {
    title: 'Help',
    layout: 'main',
  },
};

export const helpGuideRoute: RouteRecordRaw = {
  path: '/help/:guideSlug',
  name: 'HelpGuide',
  redirect: (to) => {
    const guide = findGuide(String(to.params['guideSlug']));
    const firstPage = guide?.pages[0];

    if (!guide || !firstPage) {
      return { name: 'Help' };
    }

    return {
      name: 'HelpGuidePage',
      params: { guideSlug: guide.slug, pageSlug: firstPage.slug },
    };
  },
};

export const helpGuidePageRoute: RouteRecordRaw = {
  path: '/help/:guideSlug/:pageSlug',
  name: 'HelpGuidePage',
  component: () => import('./pages/HelpGuidePage.vue'),
  props: (route) => ({
    guideSlug: String(route.params['guideSlug']),
    pageSlug: String(route.params['pageSlug']),
  }),
  meta: {
    title: 'Help',
    layout: 'main',
  },
};
